export class SmartTagBase {

	public get cssClass(): string {
		return `paragraph-${this.onlyTextBlock.length}`;
	}
	public textBlocks = [];
	public title = '';

	private onlyTextBlock = [];

	/**
	 * doc must
	 * @param text 
	 */
	public addText(text: string): void {
		if (this.textBlocks.length > 0) {
			this.textBlocks.push('<br>');
		}

		this.textBlocks.push(text);
		this.onlyTextBlock.push(text);
	}

	public appendText(text: string): void {
		if (this.textBlocks.length > 0) {
			this.textBlocks.unshift('<br>');
		}

		this.textBlocks.unshift(text);
		this.onlyTextBlock.unshift(text);
	}

	public getOutputData(version: string): any {
		let obj;
		if(version === 'v1') {
			this.appendText(this.title);
			obj = this.textBlocks.join('');
		}

		if(version === 'v2') {
			obj = {
				title: this.title,
				description: this.textBlocks.join('')
			};
		}
		
		return obj;
	}
}
